import { useState } from 'react'
import { Head } from '@inertiajs/react'
import { Switch } from '@/components/design-system'
import { cn } from '@/lib/utils'
import { privacyContent, type Lang } from './content'

const PrivacyPolicy = () => {
  const [lang, setLang] = useState<Lang>('pt')
  const content = privacyContent[lang]

  return (
    <>
      <Head title={content.pageTitle} />

      <div className="min-h-screen bg-background">
        <div className="max-w-4xl mx-auto px-6 py-12">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">
              {content.heading}
            </h1>
            <p className="text-muted-foreground">
              {content.lastUpdated}
            </p>

            {/* Language Toggle */}
            <div className="flex items-center gap-2 mt-4">
              <span className={cn('text-sm font-medium', lang === 'en' ? 'text-foreground' : 'text-muted-foreground')}>
                EN
              </span>
              <Switch
                checked={lang === 'pt'}
                onChange={(checked) => setLang(checked ? 'pt' : 'en')}
              />
              <span className={cn('text-sm font-medium', lang === 'pt' ? 'text-foreground' : 'text-muted-foreground')}>
                PT
              </span>
            </div>
          </div>

          {/* Content */}
          <div className="prose prose-gray max-w-none space-y-8">

            {/* Introduction */}
            <section className="space-y-4">
              {content.introduction.map((paragraph, i) => (
                <p key={i} className="text-foreground leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </section>

            {/* Numbered Sections (1-11) */}
            {content.sections.map((section, i) => (
              <section key={i} className="space-y-4">
                <h2 className="text-2xl font-semibold text-foreground">
                  {section.title}
                </h2>
                {section.paragraphs.map((paragraph, j) => (
                  <p key={j} className="text-foreground leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </section>
            ))}

            {/* 12. Contact */}
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">
                {content.contact.title}
              </h2>
              <div className="bg-muted rounded-lg p-6">
                <p className="text-foreground mb-4 leading-relaxed">
                  {content.contact.description}
                </p>
                <p className="text-foreground">
                  <strong>{content.contact.emailLabel}</strong>{' '}
                  <a href="mailto:privacidade@stationzero.ai" className="text-blue-600 hover:text-blue-800">
                    privacidade@stationzero.ai
                  </a>
                </p>
              </div>
            </section>

            {/* 13. Applicable Law / Legislação Aplicável */}
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">
                {content.legislation.title}
              </h2>
              {content.legislation.paragraphs.map((paragraph, i) => (
                <p key={i} className="text-foreground leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </section>

          </div>
        </div>
      </div>
    </>
  )
}

export default PrivacyPolicy
